import ApplyAttributes from "Components/ApplyAttributes/ApplyAttributes";
import AutomaticallyListedAttributes from "Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes";
import ExecuteAxios from "Components/ExecuteAxios/ExecuteAxios";
import LoadingIndicator from "Components/LoadingIndicator/LoadingIndicator";
import Panel from "Components/Panel/Panel";
import PanelListDefault from "Components/PanelListDefault/PanelListDefault";
import ResetVariables from "Components/ResetVariables/ResetVariables";
import React, { useEffect, useState } from "react";

const BenefitsDayEmployeeList = ({
    costDayIdSelecteds,
    updating,
    currentMonth,
    showNewBenefitMonthPanel,
    onUpdateInsertBenefit,
    updatePanelCostSpreadsheet,
    onUpdatePanelCostSpreadsheet,
    onUpdating,
    onUpdateReloadSalaryBenefitsCost
}) => {
    const [idBenefitSelected, setIdBenefitSelected] = useState(null)
    const [benefitDsBenefit, setBenefitDsBenefit] = useState(null)
    const [realValueBenefit, setRealValueBenefit] = useState(null)
    const [expectedValueBenefit, setExpectedValueBenefit] = useState(null)
    const [dsEmployee, setDsEmployee] = useState(null)
    const [username, setUsername] = useState(null);
    const [updateDate, setUpdateDate] = useState(null);

    const [benefitIdSelecteds, setBenefitIdSelecteds] = useState([])
    const [benefitsListByIdBenefit, setBenefitsListByIdBenefit] = useState(null)

    const [loadBenefitsMonthPanel, setLoadBenefitsMonthPanel] = useState(null);
    const [loadBenefitsEmployeeList, setLoadBenefitsEmployeeList] = useState(false);
    const [benefitListDetail, setBenefitListDetail] = useState(null);

    const attributeList = [
        { name: "id", value: idBenefitSelected, setter: setIdBenefitSelected, allowsMultipleRecordsSelected: true },
        { name: "dsBenefits", value: benefitDsBenefit, setter: setBenefitDsBenefit },
        {
            name: "value",
            value: realValueBenefit,
            setter: setRealValueBenefit
        },
        { name: "expectedValue", value: expectedValueBenefit, setter: setExpectedValueBenefit },
        { name: "employeeName", value: dsEmployee, setter: setDsEmployee },
        { name: "username", value: username, setter: setUsername, readOnly: 'S' },
        { name: "dtUpdate", value: updateDate, setter: setUpdateDate, readOnly: 'S' },
    ];

    const setBenefitsList = async (costDayIdSelected) => {
        const parameters = {
            employeeId: costDayIdSelected,
            currentMonth: currentMonth
        }
        const benefitsList = await ExecuteAxios.api('get', '/benefits-month/benefits-month-by-id/', { params: parameters });
        setBenefitsListByIdBenefit(benefitsList)

        if (!costDayIdSelected || costDayIdSelected.length === 0) {
            ResetVariables.resetVariables(attributeList);
        }
    }

    useEffect(() => {
        setLoadBenefitsEmployeeList(false)
        if (costDayIdSelecteds || costDayIdSelecteds.length === 1) {
            setBenefitsList(costDayIdSelecteds[0])
        } else {
            setBenefitsList(null)
        }
    }, [costDayIdSelecteds, showNewBenefitMonthPanel, updating === false, loadBenefitsEmployeeList === true])

    function getListBenefitsByIdUser() {
        if (!updating) {
            return (
                <PanelListDefault
                    onUpdateIdSelected={setBenefitIdSelecteds}
                    idsSelected={benefitIdSelecteds}
                    data={benefitsListByIdBenefit}
                    attributeList={attributeList}
                />
            )
        } else {
            return (
                <AutomaticallyListedAttributes
                    list={benefitListDetail}
                    attributeList={attributeList}
                    readOnlyAttributes={!updating}
                />
            )
        }
    }

    const setBenefitsAttributesDetail = async (benefitIdSelected) => {
        const parameters = { id: benefitIdSelected }
        const benefitMonth = await ExecuteAxios.api('get', `/benefits-month/selected-benefits-month-by-id/`, { params: parameters })
        setBenefitListDetail(benefitMonth)
        if (benefitMonth) {
            ApplyAttributes.applyAttributes(benefitMonth, attributeList)
        }

        if (!benefitIdSelected || benefitIdSelected.length === 0) {
            ResetVariables.resetVariables(attributeList);
        }
    };

    useEffect(() => {
        if (benefitIdSelecteds && benefitIdSelecteds.length === 1) {
            setBenefitsAttributesDetail(benefitIdSelecteds[0]);
        } else {
            setBenefitsAttributesDetail(null);
        }
    }, [benefitIdSelecteds, updating]);

    async function putCostDay() {
        if (benefitIdSelecteds && benefitIdSelecteds.length === 1) {
            try {
                setLoadBenefitsMonthPanel(true)
                const response = ExecuteAxios.api('put', `/benefits-month/update-benefits-month/`, {
                    id: idBenefitSelected,
                    valueBenefit: realValueBenefit,
                    expectedValue: expectedValueBenefit

                });

                if (response) {
                    onUpdatePanelCostSpreadsheet(true)
                    onUpdateReloadSalaryBenefitsCost(true)
                }

                return response;
            } finally {
                setLoadBenefitsMonthPanel(false)
            }
        }
    }

    const costDayStyle = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        zIndex: '0'
    }

    async function deleteBenefitItemMonth() {
        if (benefitIdSelecteds) {
            try {
                setLoadBenefitsMonthPanel(true)
                const response = await ExecuteAxios.api('delete', `/benefits-month/`, {
                    params: {
                        ids: benefitIdSelecteds.join(",")
                    }
                });

                if (response) {

                    setBenefitIdSelecteds([])
                    onUpdatePanelCostSpreadsheet(true)
                    setLoadBenefitsEmployeeList(true)
                    onUpdateReloadSalaryBenefitsCost(true)
                }
                return response
            } finally {
                setLoadBenefitsMonthPanel(false)
            }
        }
    }

    return (
        <LoadingIndicator loaded={!loadBenefitsMonthPanel}>
            <Panel titlePage={null}
                style={costDayStyle}
                canViewCRUD={true}
                setInserting={onUpdateInsertBenefit}
                enableNewRecord={true}
                canNewRecord={!showNewBenefitMonthPanel}
                updating={updating}
                inserting={false}
                enableDelete={benefitIdSelecteds && benefitIdSelecteds.length > 0}
                canDelete={true}
                deleteFunction={deleteBenefitItemMonth}
                recordsSelected={benefitIdSelecteds}
                setUpdating={onUpdating}
                putFunction={putCostDay}
                canEdit={benefitIdSelecteds && benefitIdSelecteds.length === 1}
                enableEdit={true}
                dataListedAttributes={benefitListDetail}
                attributeList={attributeList}
                onUpdateIdSelected={setBenefitIdSelecteds}
            >
                {getListBenefitsByIdUser()}
            </Panel>
        </LoadingIndicator>
    )
}

export default BenefitsDayEmployeeList;